module.exports = __webpack_public_path__ + "img/img (2).6d8b7059.jpeg";